<template>
  <div class="new-assignment">
    <organization-breadcrumb :items="breadcrumbByRoute" />
    <div class="create-assignment-page">
      <head-section
        :lessonSelected="lessonSelected"
        :lessonLoaded="lessonLoaded"
        :step="createAssignmentSteps.active"
      />
      <div class="form-section">
        <assignment-create-detail
          v-if="createAssignmentSteps.active === 1"
          :currentStep="createAssignmentSteps.active"
          :componentStep="1"
          v-on:next-step="handleNextStep"
          v-on:previous-step="handlePreviousStep"
          ref="assignment_detail"
          key="assignmentDetail"
        />
      </div>
      <div class="content-type" v-if="createAssignmentSteps.active === 2">
        <div class="el-col el-col-8 type active">
          <p class="name-type">{{ $t("homework.create_assignment.skill") }}</p>
          <p class="number-type">{{ $t("homework.create_assignment.23_skills") }}</p>
          <skills-bg width="100%" />
        </div>
        <div class="el-col el-col-8 type">
          <p class="name-type" style="color: #8e8e93">{{ $t("homework.create_assignment.topics") }}</p>
          <p class="number-type" style="color: #8e8e93">{{ $t("homework.create_assignment.15_categories") }}</p>
          <topics-bg />
        </div>
        <div class="el-col el-col-8 type">
          <p class="name-type" style="color: #8e8e93">{{ $t("homework.create_assignment.game_types") }}</p>
          <p class="number-type" style="color: #8e8e93">{{ $t("homework.create_assignment.6_game_types") }}</p>
          <gametypes-bg />
        </div>
      </div>
      <assignment-tabs v-model="selectedTab" v-if="createAssignmentSteps.active === 2" :counts="lessonCountByType">
        <template #skill>
          <div class="filter-section">
            <div class="filter-group">
              <label class="filter-title"> {{ $t("homework.create_assignment.filter_by_level") }} </label>
              <el-checkbox-group class="elsa-checkbox-group checkbox-filter" v-model="checkDifficultLevel">
                <el-checkbox class="elsa-checkbox" label="EASY">
                  {{ $t("homework.create_assignment.easy") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="MEDIUM">
                  {{ $t("homework.create_assignment.medium") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="DIFFICULT">
                  {{ $t("homework.create_assignment.difficult") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="VERY_DIFFICULT">
                  {{ $t("homework.create_assignment.very_difficult") }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="skills-section">
            <assignment-skills
              v-on:next-step="handleNextStep"
              v-on:previous-step="handlePreviousStep"
              :data="getThemeLessonWithFilter"
              :componentStep="2"
              :currentStep="createAssignmentSteps.active"
              ref="select_lesson"
              v-on:add-lesson="handelAddLesson"
              v-on:remove-lesson="handelRemoveLesson"
              v-on:add-submodule="handelAddSubModule"
              v-on:remove-submodule="handelRemoveSubModule"
              :lesson-selected="lessonSelected"
              :submodule-selected="submoduleSelected"
              :filter-selected="checkDifficultLevel"
            />
          </div>
        </template>
        <template #topic>
          <div class="filter-section">
            <div class="filter-group">
              <label class="filter-title"> {{ $t("homework.create_assignment.filter_by_level") }} </label>
              <el-checkbox-group class="elsa-checkbox-group checkbox-filter" v-model="checkDifficultLevelTopic">
                <el-checkbox class="elsa-checkbox" label="EASY">
                  {{ $t("homework.create_assignment.easy") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="MEDIUM">
                  {{ $t("homework.create_assignment.medium") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="DIFFICULT">
                  {{ $t("homework.create_assignment.difficult") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="VERY_DIFFICULT">
                  {{ $t("homework.create_assignment.very_difficult") }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="filter-group">
              <label class="filter-title"> {{ $t("homework.create_assignment.filter_by_english_level") }} </label>
              <el-checkbox-group class="elsa-checkbox-group checkbox-filter" v-model="checkCerfLevelTopic">
                <el-checkbox class="elsa-checkbox" label="level_novice">
                  {{ $t("homework.create_assignment.level_novice") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="level_upper_beginner">
                  {{ $t("homework.create_assignment.level_upper_beginner") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="level_lower_intermediate">
                  {{ $t("homework.create_assignment.level_lower_intermediate") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="level_upper_intermediate">
                  {{ $t("homework.create_assignment.level_upper_intermediate") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="level_advanced">
                  {{ $t("homework.create_assignment.level_advanced") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="mixed_level">
                  {{ $t("homework.create_assignment.mixed_level") }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="filter-group filter-topic">
              <div
                v-for="topic in getCategoryTopicList"
                :key="topic.id"
                :style="`--bg-image: url('${topic.bg_image_link}');`"
                class="topic-card"
                :class="{
                  'is-active': topic.id === selectedTopic.id,
                  'use-background-link': topic.bg_image_link,
                  'background-default': !topic.bg_image_link,
                }"
                @click="handleSelectTopic(topic)"
              >
                <span class="name">{{ topic.name }}</span>
                <!-- <span class="number">{{topic.topics_count}} {{ topic.topics_count > 1 ? $t('homework.create_assignment.topics') : $t('homework.create_assignment.topic') }}</span> -->
              </div>
            </div>
          </div>
          <div class="skills-section">
            <assignment-skills
              v-on:next-step="handleNextStep"
              v-on:previous-step="handlePreviousStep"
              :data="getThemeLessonTopicWithFilter"
              :componentStep="2"
              :currentStep="createAssignmentSteps.active"
              ref="select_lesson"
              v-on:add-lesson="handelAddLesson"
              v-on:remove-lesson="handelRemoveLesson"
              v-on:add-submodule="handelAddSubModule"
              v-on:remove-submodule="handelRemoveSubModule"
              :lesson-selected="lessonSelected"
              :submodule-selected="submoduleSelected"
              :filter-selected="checkDifficultLevel"
              filter-options-by="skill"
            />
          </div>
        </template>
        <template #premium>
          <div class="filter-section">
            <div class="filter-group">
              <label class="filter-title"> {{ $t("homework.create_assignment.filter_by_english_level") }} </label>
              <el-checkbox-group class="elsa-checkbox-group checkbox-filter" v-model="checkCerfLevelPremium">
                <el-checkbox class="elsa-checkbox" label="level_novice">
                  {{ $t("homework.create_assignment.level_novice") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="level_upper_beginner">
                  {{ $t("homework.create_assignment.level_upper_beginner") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="level_lower_intermediate">
                  {{ $t("homework.create_assignment.level_lower_intermediate") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="level_upper_intermediate">
                  {{ $t("homework.create_assignment.level_upper_intermediate") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="level_advanced">
                  {{ $t("homework.create_assignment.level_advanced") }}
                </el-checkbox>
                <el-checkbox class="elsa-checkbox" label="mixed_level">
                  {{ $t("homework.create_assignment.mixed_level") }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="filter-group filter-book">
              <div
                v-for="book in getBookLessonWithFilter"
                :key="book.id"
                :style="`--bg-image: url('${book.bg_image_link}');`"
                class="topic-card"
                :class="{
                  'is-active': book.id === selectedBook.id,
                  'use-background-link': book.bg_image_link,
                  'background-default': !book.bg_image_link,
                }"
                @click="handleSelectBook(book)"
              >
                <span class="name">{{ truncateBookName(book.name) }}</span>
              </div>
            </div>
          </div>
          <div class="skills-section">
            <assignment-books
              v-on:next-step="handleNextStep"
              v-on:previous-step="handlePreviousStep"
              :data="selectedBook"
              :componentStep="2"
              :currentStep="createAssignmentSteps.active"
              ref="select_lesson"
              v-on:add-lesson="handelAddLesson"
              v-on:remove-lesson="handelRemoveLesson"
              :lesson-selected="lessonSelected"
            />
          </div>
        </template>
      </assignment-tabs>
      <div class="content-section">
        <assignment-review
          v-on:next-step="handleNextStep"
          v-on:previous-step="handlePreviousStep"
          v-if="createAssignmentSteps.active === 3"
          :componentStep="3"
          :currentStep="createAssignmentSteps.active"
          :data-skill="getThemeLessonList"
          :data-topic="getThemeLessonTopicList"
          :data-book="getBookLessonList"
          v-on:remove-lesson="handelRemoveLesson"
          v-on:remove-submodule="handelRemoveSubModule"
          :lesson-selected="lessonSelected"
          :lesson-selected-topic="lessonSelectedTopic"
          :lesson-selected-book="lessonSelectedBook"
          ref="assignment_review"
        />
      </div>
      <assignment-create-footer
        :class="createAssignmentSteps.active === 1 ? 'form-footer' : ''"
        :primaryPreviousText="previousText()"
        :cancelActive="false"
        :primaryPreviousActive="true"
        :primaryAction="clickContinue"
        :primaryPreviousAction="handlePreviousStep"
        :previousShowIcon="previousShowIcon()"
        :primaryText="primaryText()"
        :previousText="previousText()"
        :primaryDisabled="createAssignmentSteps.active > 1 && !lessonSelected.length > 0"
      />
    </div>

    <assign-to-class-success-modal
      :dialogVisible="modals.showAssignToClassSuccess"
      append-to-body
      :page="1"
      :show-close="false"
      v-on:closed="handleReviewAssignmentSuccess"
      :createdAssignments="createdAssignments"
    />
    <!-- <assign-to-class-success-modal
      :dialogVisible="true"
      append-to-body
      :page="1"
      :show-close="false"
      v-on:closed="handleReviewAssignmentSuccess"
      :createdAssignments="createdAssignments"
    /> -->
    <leave-create-assignment-modal
      :dialogVisible="modals.showLeaveCreateAssignmentModal"
      append-to-body
      v-on:closed="modals.showLeaveCreateAssignmentModal = false"
      v-on:leave="handleConfirmLeaveAssignment"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OrganizationBreadcrumb from "@/components/common/OrganizationBreadcrumb";
import SkillsBg from "@/assets/images/inline.skill.svg";
import TopicsBg from "@/assets/images/inline.topic.svg";
import GametypesBg from "@/assets/images/inline.game_types.svg";
import HeadSection from "@/components/homeworks/create-assignments/HeadSection";
import AssignmentCreateFooter from "@/components/homeworks/create-assignments/AssignmentCreateFooter";
import AssignmentSkills from "@/components/homeworks/create-assignments/AssignmentSkills";
import AssignmentReview from "@/components/homeworks/create-assignments/AssignmentReview";
import AssignmentCreateDetail from "@/components/homeworks/create-assignments/AssignmentCreateDetail";
import LeaveCreateAssignmentModal from "@/components/modals/homeworks/LeaveCreateAssignment";
import AssignToClassSuccessModal from "@/components/modals/studysets/AssignToClassSuccessModal";
import { pathOr } from "ramda";
import { successMessage } from "@/utils/messages";
import AssignmentTabs from "@/components/homeworks/AssignmentTabs";
import AssignmentBooks from "@/components/homeworks/create-assignments/AssignmentBooks";
import axios from "@/utils/axios";
import { arrayUnique } from "@/helpers/functions";

export default {
  components: {
    AssignmentReview,
    OrganizationBreadcrumb,
    SkillsBg,
    TopicsBg,
    GametypesBg,
    AssignmentCreateFooter,
    AssignmentSkills,
    HeadSection,
    AssignmentCreateDetail,
    LeaveCreateAssignmentModal,
    AssignToClassSuccessModal,
    AssignmentTabs,
    AssignmentBooks,
  },
  computed: {
    ...mapGetters("user", ["isElsaAdmin"]),
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
      currentOrganizationId: "organization/currentOrganizationId",
      userIsTeacher: "organization/isOrganizationTeacher",
      userIsAdmin: "organization/isOrganizationAdmin",
      userIsAssociateAdmin: "organization/isOrganizationAssociateAdmin",
      currentUserId: "user/getUserId",
      getThemeLessonList: "homeworks/getThemeLessonList",
      getThemeLessonTopicList: "homeworks/getThemeLessonTopicList",
      buildingAssignments: "homeworks/getBuildingAssignment",
      createdAssignments: "homeworks/getCreatedAssignments",
      getCategoryTopicList: "homeworks/getCategoryTopicList",
      getBookLessonList: "homeworks/getBookLessonList",
    }),
    ...mapGetters("classes", ["getCurrentClass"]),
    assignments() {
      return pathOr([], ["buildingAssignments", "assignments"])(this);
    },
    getThemeLessonWithFilter() {
      const resultFilter = JSON.parse(JSON.stringify(this.getThemeLessonList));
      if (this.checkDifficultLevel.length > 0)
        resultFilter.forEach(item => {
          item.modules.forEach(module => {
            module.submodules = module.submodules.filter(submodule => {
              submodule.lessons = submodule.lessons.filter(lesson => {
                return this.checkDifficultLevel.includes(lesson.difficulty_level);
              });
              return submodule.lessons.length;
            });
          });
        });
      return resultFilter;
    },
    getThemeLessonTopicWithFilter() {
      let resultFilter = JSON.parse(JSON.stringify(this.getThemeLessonTopicList));

      if (this.selectedTopic.id !== undefined && this.selectedTopic.topics) {
        resultFilter = resultFilter.filter(item => {
          return this.selectedTopic.topics.includes(item.id);
        });
      }
      if (this.checkCerfLevelTopic.length > 0) {
        resultFilter = resultFilter.filter(item => {
          let intersection = this.checkCerfLevelTopic.filter(x => item.cerf_level.includes(x));
          return intersection.length > 0;
        });
      }
      if (this.checkDifficultLevelTopic.length > 0) {
        resultFilter.forEach(item => {
          item.modules.forEach(module => {
            module.submodules = module.submodules.filter(submodule => {
              submodule.lessons = submodule.lessons.filter(lesson => {
                return this.checkDifficultLevelTopic.includes(lesson.difficulty_level);
              });
              return submodule.lessons.length;
            });
          });
        });
      }
      return resultFilter;
    },
    getBookLessonWithFilter() {
      let resultFilter = this.getBookLessonList;
      if (this.checkCerfLevelPremium.length > 0) {
        resultFilter = resultFilter.filter(item => {
          let intersection = this.checkCerfLevelPremium.filter(x => item.cerf_level.includes(x));
          return intersection.length > 0;
        });
      }
      return resultFilter;
    },
    breadcrumbByRoute() {
      let items = [];
      if (this.currentRoute === "assignment-library-new") {
        items.push(this.$t("homework_library.curriculum"));
      } else {
        items.push(this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "groups")));
      }
      items.push(this.$t("homework.create_new_assignment"));
      return items;
    },
  },
  data() {
    return {
      modals: {
        showLeaveCreateAssignmentModal: false,
        showAssignToClassSuccess: false,
      },
      checkDifficultLevel: [],
      checkDifficultLevelTopic: [],
      lessonLoaded: false,
      lessonSelected: [],
      lessonSelectedTopic: [],
      lessonSelectedSkill: [],
      lessonSelectedBook: [],
      submoduleSelected: [],
      createAssignmentSteps: {
        active: 1,
      },
      primaryLoading: false,
      currentRoute: "assignment-new",
      selectedTopic: {},
      lessonCountByType: {
        skill: 0,
        topic: 0,
        premium: 0,
      },
      selectedTab: "skill",
      checkCerfLevelTopic: [],
      checkCerfLevelPremium: [],
      selectedBook: {},
      product_content_ids: [],
    };
  },
  methods: {
    clickContinue() {
      switch (this.createAssignmentSteps.active) {
        case 1:
          this.$refs.assignment_detail.handleContinueClick();
          break;
        case 2:
          this.$refs.select_lesson.setLesson();
          break;
        case 3:
          this.$refs.assignment_review.createAssignment();
          break;
        default:
          return;
      }
    },
    handelAddLesson(lessons) {
      lessons.forEach(lesson => {
        if (!this.lessonSelected.includes(lesson)) {
          this.lessonSelected.push(lesson);
          this.lessonCountByType[this.selectedTab]++;
          if (this.selectedTab === "topic") {
            this.lessonSelectedTopic.push(lesson);
          }
          if (this.selectedTab === "skill") {
            this.lessonSelectedSkill.push(lesson);
          }
          if (this.selectedTab === "premium") {
            this.lessonSelectedBook.push(lesson)
          }
        }
      });
      // this.lessonSelected = [...this.lessonSelected, ...lessons];
    },
    handelRemoveLesson(lessons) {
      const number = this.lessonSelected.length;
      this.lessonSelected = this.lessonSelected.filter(lesson => !lessons.includes(lesson));
      if (this.selectedTab === "topic") {
        this.lessonSelectedTopic = this.lessonSelectedTopic.filter(lesson => !lessons.includes(lesson));
      }
      if (this.selectedTab === "skill") {
        this.lessonSelectedSkill = this.lessonSelectedSkill.filter(lesson => !lessons.includes(lesson));
      }
      const numberAfter = this.lessonSelected.length;
      this.lessonCountByType[this.selectedTab] += numberAfter - number;
    },
    handelAddSubModule(submodule) {
      this.submoduleSelected.push(submodule);
    },
    handelRemoveSubModule(submodule) {
      let index = this.submoduleSelected.indexOf(submodule);
      if (index > -1) this.submoduleSelected.splice(index, 1);
    },
    ...mapActions({
      getThemeLessons: "homeworks/getThemeLessons",
      updateBuildingAssignment: "homeworks/updateBuildingAssignment",
      createAssignment: "homeworks/createAssignments",
      createAssignmentLibrary: "homeworks/createAssignmentLibrary",
      getCategoryTopics: "homeworks/getCategoryTopics",
      getContentBooks: "homeworks/getContentBooks",
    }),
    handleNextStep() {
      const activeStep = this.createAssignmentSteps.active;
      if (this.createAssignmentSteps.active === 3) {
        this.$refs.assignment_review.$refs.assignment_detail.validateForm(this.handleCreateAssignment);
      } else {
        this.createAssignmentSteps.active = activeStep + 1;
      }
    },
    handlePreviousStep() {
      const activeStep = this.createAssignmentSteps.active;
      if (activeStep === 1) this.modals.showLeaveCreateAssignmentModal = true;
      else this.createAssignmentSteps.active = activeStep - 1;
    },
    handleConfirmLeaveAssignment() {
      this.$store.dispatch("homeworks/resetHomeworkAssignment");
      let classId = this.getCurrentClass.id;
      let organizationId = this.currentOrganizationId;
      if (this.$router.currentRoute.name === "assignment-library-new") {
        return this.$router.push({
          name: "assignment-library",
          params: {
            organizationId,
          },
        });
      }
      return this.$router.push({
        name: "class-details",
        params: {
          organizationId,
          classId,
          active_component: "assignment-list",
          active_entry: "4",
        },
        hash: "#assignment",
      });
    },
    async handleCreateAssignment() {
      this.updateBuildingAssignment({
        lesson_original_ids: this.lessonSelected,
        assignments: this.assignments,
      });
      try {
        const newAssignment = this.assignments[0];
        this.primaryLoading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        // Create assignment library first
        let assignmentLibrary = {
          name: newAssignment.name,
          lesson_original_ids: this.lessonSelected,
          study_sets: [],
          shareable: newAssignment.shareable,
        };
        let assignment_library_id = await this.createAssignmentLibrary(assignmentLibrary);
        if (newAssignment.groupIds.length > 0) {
          // Then assign assignment above to class
          await this.createAssignment(assignment_library_id);
          this.primaryLoading.close();
          this.modals.showAssignToClassSuccess = true;
        } else {
          this.primaryLoading.close();
          successMessage(this.$t("homework_library.create_success"), "elsa-message success", {
            showClose: false,
          })(this);
          this.handleConfirmLeaveAssignment();
        }
      } catch (error) {
        this.errors = error;
        this.primaryLoading.close();
      }
    },
    handleReviewAssignmentSuccess() {
      this.modals.showAssignToClassSuccess = false;
      this.handleConfirmLeaveAssignment();
    },
    primaryText() {
      switch (this.createAssignmentSteps.active) {
        case 1:
          return this.$t("homework.buttons.select_lesson");
        case 2:
          return this.$t("homework.buttons.review");
        case 3:
          return this.$t("homework.buttons.create_assignment");
        default:
          return this.$t("homework.buttons.select_lesson");
      }
    },
    previousText() {
      if (this.createAssignmentSteps.active === 1) {
        return this.$t("homework.buttons.cancel");
      } else {
        return this.$t("homework.buttons.back");
      }
    },
    previousShowIcon() {
      if (this.createAssignmentSteps.active === 1) {
        return false;
      } else {
        return true;
      }
    },
    handleSelectTopic(topic) {
      if (this.selectedTopic === topic) {
        this.selectedTopic = {
          id: undefined,
        };
      } else {
        this.selectedTopic = topic;
      }
    },
    handleSelectBook(book) {
      if (this.selectedBook === book) {
        this.selectedBook = {
          id: undefined,
        };
      } else {
        this.selectedBook = book;
      }
    },
    getPayments() {
      let url_payments = `v1/checkouts/${this.currentOrganizationId}/payments`;
      let product_content_ids = [];
      axios.get(url_payments)
      .then(response => {
        const payments = response.data;
        payments.forEach(payment => {
          const plan_details = payment.plan_details;
          plan_details.forEach(plan => {
            if (plan.product_content_ids)
              product_content_ids = [...product_content_ids, ...plan.product_content_ids];
          })
        });
        this.product_content_ids = arrayUnique(product_content_ids);
      })
      .catch(error => {
        this.errors = error;
      });

    },
    truncateBookName(bookName) {
      const words = bookName.split(' ');
      const truncatedWords = words.slice(0, 5);
      const truncatedName = truncatedWords.join(' ');

      if (words.length > 5) {
        return `${truncatedName}...`;
      }

      return truncatedName;
    },
  },
  destroyed() {
    this.$store.dispatch("homeworks/resetHomeworkAssignment");
  },
  created() {
    this.currentRoute = this.$router.currentRoute.name;
  },
  mounted() {
    try {
      this.getThemeLessons({ type: "skill" });
      this.getThemeLessons({ type: "topic" });
      this.getPayments();
      this.getCategoryTopics();
    } catch (error) {
      // console.error(error);
    }
  },
  watch: {
    getCategoryTopicList: {
      handler(val) {
        this.selectedTopic = val[0];
      },
      deep: true,
    },
    getBookLessonList: {
      handler(val) {
        this.selectedBook = val[0];
      },
      deep: true,
    },
    getBookLessonWithFilter: function(newVal) {
      if (newVal.length == 0) {
        this.selectedBook = {};
      } else {
        this.selectedBook = newVal[0];
      }
    },
    product_content_ids: {
      handler(val) {
        // if (val.length > 0) {
          const topic_ids = val;
          this.getContentBooks({ topic_ids: topic_ids.join(","), organization_id: this.currentOrganizationId });
        // }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
@media only screen and (max-width: 992px) {
  .component-wrapper {
    margin-top: 30px;
  }
  .form-section {
    width: 320px !important;
  }
}
.new-assignment {
  width: 100%;
}
.create-assignment-page {
  .number-chip {
    justify-self: flex-end;
    &,
    &:active,
    &:focus,
    &:hover {
      padding: 8px 16px;
    }
    .number {
      font-size: 12px;
      border-radius: 100%;
      background-color: $purple;
      color: $white;
      width: 18px;
      height: 18px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      transition: background 0.2s, font-weight 0.2s;
      float: right;
      margin-left: -20px;
    }
  }
  margin: 40px;
  .form-section {
    margin-top: 36px;
    width: 680px;
  }
  .form-footer {
    width: 680px;
  }
  .content-type {
    display: none;
    padding: 20px 0px;
    .name-type {
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 24px;
      display: flex;
      align-items: center;
      letter-spacing: 0.75px;
      position: absolute;
      color: #fff;
      margin: 16px 16px;
      opacity: 0.5;
    }
    .number-type {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      display: flex;
      align-items: center;
      letter-spacing: 0.25px;
      color: rgba(255, 255, 255, 0.8);
      opacity: 0.5;
      position: absolute;
      margin: 40px 16px;
    }
    .type {
      cursor: pointer;
    }
    .active {
      .name-type {
        opacity: 1;
      }
    }
  }
  .filter-section {
    width: 100%;
    min-height: 104px;
    background: #efeff4;
    border-radius: 12px;
    margin: 20px 0px;
    .filter-group {
      padding: 16px 24px;
    }
    .filter-title {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.25px;
      color: #8e8e93;
    }
    .checkbox-filter {
      flex-direction: revert;
      padding-top: 5px;
    }
    ::v-deep .elsa-checkbox-group .elsa-checkbox .el-checkbox__label {
      font-weight: normal !important;
      font-size: 16px !important;
      line-height: 24px !important;
      letter-spacing: 0.25px !important;
      color: #121131 !important;
    }
    .filter-topic,
    .filter-book {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
      grid-template-columns: repeat(auto-fit, minmax(210px, 210px));
      gap: 10px;
      // &::after {
      //   content: '';
      //   flex-grow: 100000;
      // }
    }
    .topic-card {
      // width: 202px;
      height: 72px;
      background: #e9e8e5;
      border-radius: 16px;
      padding: 12px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      background-size: cover;
      background-position-y: -16px;
      background-blend-mode: overlay;
      cursor: pointer;
      .name {
        font-size: 18px;
        font-weight: 600;
        color: #8e8e93;
        text-transform: uppercase;
      }
      .number {
        font-size: 12px;
        color: #8e8e93;
        text-transform: lowercase;
      }
      &.is-active {
        background-blend-mode: normal;
        .name {
          color: #fff;
        }
        .number {
          color: #fff;
        }
      }
      &.use-background-link {
        background-image: var(--bg-image);
        background-size: cover;
      }
      &.background-default {
        background-image: url("~@/assets/images/default-topic-bg.svg");
        background-size: cover;
      }
    }
  }
}
.review-assignment-page {
  .number-chip {
    justify-self: flex-end;
    &,
    &:active,
    &:focus,
    &:hover {
      padding: 8px 16px;
    }
    .number {
      font-size: 12px;
      border-radius: 100%;
      background-color: $purple;
      color: $white;
      width: 18px;
      height: 18px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      transition: background 0.2s, font-weight 0.2s;
      float: right;
      margin-left: -20px;
    }
  }
  margin: 40px;
  .head-section {
    padding: 0px 0px 20px;
    display: flex;
    i.elsa-icon-cart {
      float: right;
    }
    .pages-completed {
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      /* identical to box height, or 133% */
      letter-spacing: 0.5px;
      color: #007eff;
    }
  }
}
.skills-loading-section {
  height: 100px;
}
.skills-section {
  margin-bottom: 40px;
}
</style>
